import Swal from 'sweetalert2'
import { SweetAlertOptions, SweetAlertResult } from 'sweetalert2'

export class DialogService {

  /**
   * 成功ダイアログを表示します
   * @param options
   * @param isForced
   * @returns
   */
  public static async success(options: SweetAlertOptions, isForced = false): Promise<SweetAlertResult<any>> {
    options.icon = 'success'
    return DialogService.open(options, isForced)
  }

  /**
   * エラーダイアログを表示します
   * @param options
   * @param isForced
   * @returns
   */
  public static async error(options: SweetAlertOptions, isForced = false): Promise<SweetAlertResult<any>> {
    options.icon = 'error'
    return DialogService.open(options, isForced)
  }

  /**
   * 警告ダイアログを表示します
   * @param options
   * @param isForced
   * @returns
   */
  public static async warning(options: SweetAlertOptions, isForced = false): Promise<SweetAlertResult<any>> {
    options.icon = 'warning'
    return DialogService.open(options, isForced)
  }

  /**
   * お知らせダイアログを表示します
   * @param options
   * @param isForced
   * @returns
   */
  public static async info(options: SweetAlertOptions, isForced = false): Promise<SweetAlertResult<any>> {
    options.icon = 'info'
    return DialogService.open(options, isForced)
  }

  /**
   * 質問ダイアログを表示します
   * @param options
   * @param isForced
   * @returns
   */
  public static async question(options: SweetAlertOptions, isForced = false): Promise<SweetAlertResult<any>> {
    options.icon = 'question'
    return DialogService.open(options, isForced)
  }

  public static async nowloading(title: string|null = null, text: string|null = null, isForced = true): Promise<SweetAlertResult<any>> {
    const options:SweetAlertOptions = {
      title: (title) ? title : '処理中...',
      text: (text) ? text : '処理終了まで画面はそのままにしてください。',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      }
    }
    return DialogService.open(options, isForced)
  }

  public static close() {
    if (Swal.isVisible()) {
      Swal.close()
    }
  }

  /**
   * ダイアログを開きます
   * @param options
   * @param isForced
   * @returns
   */
  public static open(options: SweetAlertOptions, isForced: boolean) {
    if (!Swal.isVisible() || isForced) {
      return Swal.fire(options)
    } else {
      return this.getBlankResult()
    }
  }

  /**
   * すべてのボタン実行がされていないという戻り値を返します
   * @returns
   */
  private static getBlankResult(): SweetAlertResult<any> {
    return {
      isConfirmed: false,
      isDenied: false,
      isDismissed: false
    }
  }

}
